<template>
  <div class="mobile-why">
    <Title :title="$root.language.whyJwi"></Title>
    <p :class="['weight-bold',font16]">{{$root.language.whyRow1}}</p>
    <p :class="['weight-bold',font16]">{{$root.language.whyRow2}}</p>
    <!-- <div class="why-box text-link text-right" @click="showModal()"> -->
    <img v-if="$root.isEnglish" src="@/assets/img/per.png" width="100%" class="why-box" alt="">
    <img v-else src="@/assets/img/jwi.png" width="100%" class="why-box" @click="showModal()" alt="">
    <!-- </div> -->
    <div class="margin-top-15">
      <div :class="['weight-bold line-normal margin-bottom-20', font40]">{{$root.language.whyRow3}}</div>
    </div>
    <p :class="font16">{{$root.language.whyRow4}}</p>
    <p :class="font16">{{$root.language.whyRow5}}</p>
    <div :class="['weight-bold line-normal margin-bottom-20', font40]">{{$root.language.whyRow6}}</div>
    <p :class="font16">{{$root.language.whyRow7}}
    </p>
    <p :class="font16">{{$root.language.whyRow8}}</p>
    <div :class="['weight-bold line-normal margin-bottom-20', font40]">{{$root.language.whyRow9}}</div>
    <p :class="font16">{{$root.language.whyRow10}}</p>
    <div :class="font16" class="text-link text-red weight-bold" @click="jumpJoinUs">[ {{$root.language.contactUs}} ]</div>
    <VideoModal ref="videoModal"></VideoModal>
  </div>
</template>

<script>
import Title from '@/components/title'
import VideoModal from '@/views/company/why/video'
export default {
  components: {
    Title,
    VideoModal
  },
  computed: {
    font40: function () {
      return this.$root.isEnglish ? 'font-22' : 'font-20'
    },
    font16: function () {
      return this.$root.isEnglish ? 'font-16' : 'font-16'
    }
  },

  methods: {
    showModal () {
      if (!this.$root.isEnglish) {
        this.$refs.videoModal.openVideo()
      }
    },
    jumpJoinUs () {
      this.$router.push({
        path: '/company/contact'
      })
    }
  }
}

</script>

<style scoped>
.margin-bottom-20 {
  margin-bottom: 20px;
}
.why-box {
  margin: 15px 0;
  box-shadow: 1px 1px 25px 6px #ccc;
}
</style>
